import type { Tuple5 } from '@/common/types';

export interface LeagueStatsTableProps {
  /** Column headers – exactly 5 entries (e.g. PL, V, D, L, Pts). */
  labels: Tuple5<string>;
  /** Values for each column, in the same order as labels – exactly 5 entries. Omit to hide the table. */
  values?: Tuple5<string | number>;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function LeagueStatsTable({
  labels,
  values,
  className = '',
}: LeagueStatsTableProps) {
  if (!values) {
    return null;
  }

  const columnGridPositions = [1, 3, 4, 5, 7] as const;

  return (
    <div
      className={`grid w-fit ${className}`}
      style={{
        gridTemplateColumns: '24px 4px 24px 24px 24px 4px 24px',
        gridTemplateRows: '16px 20px',
      }}
    >
      {labels.map((label, i) => {
        const gridColumn = columnGridPositions[i];
        return (
          <span
            key={`league-stats-label-${gridColumn}`}
            className="text-center text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark font-robotoRegular text-[12px] leading-[16px]"
            style={{ gridColumn, gridRow: 1 }}
          >
            {label}
          </span>
        );
      })}
      {values.map((val, i) => {
        const gridColumn = columnGridPositions[i];
        return (
          <span
            key={`league-stats-value-${gridColumn}`}
            className="text-center text-pmw-label-primary-light dark:text-pmw-label-primary-dark font-robotoMedium font-semibold text-[14px] leading-[20px] mt-[4px]"
            style={{ gridColumn, gridRow: 2 }}
          >
            {val}
          </span>
        );
      })}
    </div>
  );
}
